import React from 'react';
import { TabDescriptor } from '../types';
import { UnreadCounts } from '../hooks/useCommandeMsUnreadCounts';

interface CommandeMsTabsProps {
  descriptors: TabDescriptor[];
  activeIndex: number;
  onSelect: (index: number) => void;
  // Compteurs de non-lus : badge sur les onglets Q&R / Messagerie quand count > 0.
  unreadCounts?: UnreadCounts | null;
}

// Survol d'un onglet DESACTIVE : dit QUAND l'onglet s'ouvrira (oriente deblocage). Meme vocabulaire
// que la vue acheteur MS (reference validee) : "consultation lancee", "analyse cloturee", "marche
// signe". Un onglet actif n'a pas de survol.
const tooltipFor = (tab: TabDescriptor): string => {
  if (tab.inactive) return 'Fonctionnalité en cours de développement';
  if (!tab.disabled) return '';
  switch (tab.kind) {
    case 'questions_reponses':
      return 'Disponible dès la consultation lancée';
    case 'candidature':
      return 'Disponible dès la consultation lancée';
    case 'notifications':
      return "Disponible dès l'analyse clôturée";
    case 'messagerie':
    case 'evaluation':
      return 'Disponible dès le marché signé';
    default:
      return 'Non disponible dans ce statut';
  }
};

// Nombre de non-lus a afficher en badge pour un onglet (0 = pas de badge).
const badgeCountFor = (tab: TabDescriptor, unreadCounts?: UnreadCounts | null): number => {
  if (!unreadCounts) return 0;
  if (tab.kind === 'questions_reponses') return unreadCounts.questions_reponses;
  if (tab.kind === 'messagerie') return unreadCounts.messagerie;
  return 0;
};

// Barre d'onglets presta MS : boutons CUSTOM calques sur CommandeTabs (case BC presta) / OperationTabs
// (case acheteur), pour une parite VISUELLE exacte (soulignement orange #f97316, tooltips
// disabled/inactive). N'utilise PAS le composant partage TabNav. Pilotee par descripteurs types :
// pas d'index magique, pas de regex ; disabled/inactive sont calcules en domaine puis lus tels quels.
const CommandeMsTabs: React.FC<CommandeMsTabsProps> = ({
  descriptors,
  activeIndex,
  onSelect,
  unreadCounts,
}) => (
  <div className="scms__tab-nav">
    <div className="scms__tab-nav-left">
      {descriptors.map((tab, index) => {
        const locked = tab.disabled || tab.inactive;
        const tooltip = tooltipFor(tab);
        const badge = badgeCountFor(tab, unreadCounts);
        const classes = ['scms__tab-button'];
        if (index === activeIndex) classes.push('active');
        if (tab.inactive) classes.push('inactive');
        if (tab.disabled) classes.push('disabled');

        return (
          <button
            key={tab.key}
            type="button"
            className={classes.join(' ')}
            onClick={() => !locked && onSelect(index)}
            disabled={locked}
            title={tooltip}
            data-tooltip={tooltip}
          >
            {tab.label}
            {badge > 0 && <span className="scms__tab-badge">{badge}</span>}
          </button>
        );
      })}
    </div>
  </div>
);

export default CommandeMsTabs;
